var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenericAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1731 26.9867H46.2635C46.2635 26.9867 44.3776 26.9867 44.0875 26.7872C42.9496 25.9757 41.8797 23.36 41.3675 22.3219C41.3343 22.2417 41.2824 22.1707 41.2161 22.1147C41.1499 22.0587 41.0712 22.0194 40.9867 22H31.0043C30.9192 22.0194 30.8399 22.0587 30.773 22.1147C30.706 22.1706 30.6532 22.2416 30.6189 22.3219C30.1339 23.36 29.0595 25.9757 27.8989 26.7872C27.6088 26.9912 25.7229 26.9867 25.7229 26.9867H20.8133C19.5349 26.9867 19 27.4944 19 28.732V48.3613C19 49.5989 19.544 50.1067 20.8133 50.1067H51.1867C52.4605 50.1067 53 49.5989 53 48.3613V28.732C52.9909 27.4944 52.4469 26.9867 51.1731 26.9867Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9908 45.007C40.1845 45.007 43.5841 41.6073 43.5841 37.4136C43.5841 33.22 40.1845 29.8203 35.9908 29.8203C31.7971 29.8203 28.3975 33.22 28.3975 37.4136C28.3975 41.6073 31.7971 45.007 35.9908 45.007Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericAvatar);
export default __webpack_public_path__ + "static/media/generic-avatar.a960a1c1211d2657244940297d4d73f8.svg";
export { ForwardRef as ReactComponent };